import React from 'react';
import { leadership } from '../data/content';

export default function Leadership() {
  return (
    <section className="leadership" id="leadership">
      <p className="section-title">Impact</p>
      <h2>Technical Leadership</h2>
      <ul className="leadership__list">
        {leadership.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    </section>
  );
}
